import script from "./AgeSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./AgeSelector.vue?vue&type=script&setup=true&lang=ts"

import "./AgeSelector.vue?vue&type=style&index=0&id=653dc965&scoped=true&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-653dc965"]])

export default __exports__